<template>
    <aside class="uk-width-1-1">
        <div class="shop-filter" uk-overflow-auto>
            <div class="uk-flex-inline@s uk-card uk-card-default uk-card-small uk-card-body">
                    <shop-filter-row v-for="property in FilterProperties"
                                     :key="property.id"
                                     :property="property"
                                     :property-values="FilterPropertyValues[property.id]"
                                     :multiple-mode.sync="multipleMode"
                                     :multiple-mode-property.sync="multipleModeProperty"
                                     :selected="selectedPropertyValues[property.id]"
                                     v-on="$listeners"
                    ></shop-filter-row>
            </div>
        </div>
    </aside>
</template>

<script>
    import ShopFilterRow from "./ShopFilterRow";

    export default {
        name: "ShopFilter",
        components: {ShopFilterRow},
        props: {
            FilterProperties: {
                type: Array,
                required: true,
            },
            FilterPropertyValues: {
                type: [Array, Object],
                required: true,
            },
            selectedPropertyValues: {
                type: [Array, Object],
                default() {
                    return {}
                }
            }
        },

        data() {
            return {
                multipleMode: false,
                multipleModeProperty: {}
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ShopFilter.vue?7e6b8616